export default {
  methods: {
    getRouteProps() {
      var routeName = this.$route.name;
      // var routeProps = this.$store.state.global.minorPages.filter(route => {
      //     return route.link == routeName;
      // });
      //return routeProps[0];

      return this.$store.state.global.pages[routeName]
    }
  },
  computed: {
    routeProps() {
      return this.getRouteProps();
    }
  }
}